import type { UsDiscoveryMarket } from './marketClient';
import { usPlayerMetadata, type UsPlayerMetadata } from './playerFamily';

/** Exact US-only contract. Display player identity is not a cross-venue join. */
export interface UsPlayerTarget {
  marketSlug: string; marketId: string; sportsMarketType: string;
  line: string | null; metadata: UsPlayerMetadata;
}

export function usPlayerTarget(market: UsDiscoveryMarket): UsPlayerTarget | null {
  const metadata = usPlayerMetadata(market.sportsMarketType, market.playerProp, market.gameKey);
  if ((market.sport !== 'NFL' && market.sport !== 'NBA') || market.marketType !== 'props' || market.period !== 'full'
    || market.yesTeam !== null || !metadata || !/^[A-Za-z0-9_-]{1,256}$/.test(market.marketSlug)
    || !/^[0-9]{1,32}$/.test(market.marketId)
    || (metadata.kind === 'threshold' ? market.line === null || !/^\d{1,4}(?:\.\d{1,2})?$/.test(market.line) : market.line !== null)) return null;
  return { marketSlug: market.marketSlug, marketId: market.marketId, sportsMarketType: market.sportsMarketType,
    line: market.line, metadata };
}

export function sameUsPlayerTarget(a: UsPlayerTarget, b: UsPlayerTarget): boolean {
  return a.marketSlug === b.marketSlug && a.marketId === b.marketId && a.sportsMarketType === b.sportsMarketType
    && a.line === b.line && a.metadata.player === b.metadata.player && a.metadata.playerTeam === b.metadata.playerTeam
    && a.metadata.stat === b.metadata.stat && a.metadata.kind === b.metadata.kind && a.metadata.period === b.metadata.period;
}
